<script lang="ts">
  import logo from '$lib/assets/img/uams-logo_main_horizontal_white.svg';
  import { itdevcontact } from '$lib/constants';

  const currentYear = new Date().getFullYear();
</script>

<footer id="footer">
  <a href="https://uams.edu/" class="logo">
    <img src={logo} alt="UAMS Logo" />
  </a>
  <div class="schema">
    <div class="schema-address">4301 West Markham Street, Little Rock, AR 72205</div>
    <div class="schema-phone">
      <span id="footer-phone-label">Phone:</span>
      <a href="tel:501-686-7000" aria-labelledby="footer-phone-label">(501) 686-7000</a>
    </div>
  </div>
  <nav aria-label="Social Media">
    <ul class="nav social">
      <li class="nav-item">
        <a class="nav-link" href="https://www.facebook.com/UAMShealth/" target="_blank" title="Facebook"
          ><svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
            ><path
              fill="currentColor"
              d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
            ></path></svg
          ><span class="visually-hidden">Facebook</span></a
        >
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://x.com/uamshealth" target="_blank" title="Twitter"
          ><svg class="svg-inline--fa fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
            ><path
              fill="currentColor"
              d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm297.1 84l-103.8 118.6 122.1 161.4-95.6 0-74.8-97.9-85.7 97.9-47.5 0 111-126.9-117.1-153.1 98 0 67.7 89.5 78.2-89.5 47.5 0zM323.3 367.6l-169.9-224.7-28.3 0 171.8 224.7 26.4 0z"
            /></svg
          ><span class="visually-hidden">Twitter</span></a
        >
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://www.instagram.com/uamshealth/" target="_blank" title="Instagram"
          ><svg class="svg-inline--fa fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
            ><path
              fill="currentColor"
              d="M224.3 141a115 115 0 1 0 -.6 230 115 115 0 1 0 .6-230zm-.6 40.4a74.6 74.6 0 1 1 .6 149.2 74.6 74.6 0 1 1 -.6-149.2zm93.4-45.1a26.8 26.8 0 1 1 53.6 0 26.8 26.8 0 1 1 -53.6 0zm129.7 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM399 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
            /></svg
          ><span class="visually-hidden">Instagram</span></a
        >
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://www.youtube.com/UAMSHealth" target="_blank" title="YouTube"
          ><svg class="svg-inline--fa fa-w-18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"
            ><path
              fill="currentColor"
              d="M549.7 124.1C543.5 100.4 524.9 81.8 501.4 75.5 458.9 64 288.1 64 288.1 64S117.3 64 74.7 75.5C51.2 81.8 32.7 100.4 26.4 124.1 15 167 15 256.4 15 256.4s0 89.4 11.4 132.3c6.3 23.6 24.8 41.5 48.3 47.8 42.6 11.5 213.4 11.5 213.4 11.5s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zM232.2 337.6l0-162.4 142.7 81.2-142.7 81.2z"
            /></svg
          ><span class="visually-hidden">YouTube</span></a
        >
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://www.linkedin.com/company/uams/" target="_blank" title="LinkedIn"
          ><svg class="svg-inline--fa fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
            ><path
              fill="currentColor"
              d="M416 32L31.9 32C14.3 32 0 46.5 0 64.3L0 447.7C0 465.5 14.3 480 31.9 480L416 480c17.6 0 32-14.5 32-32.3l0-383.4C448 46.5 433.6 32 416 32zM135.4 416l-66.4 0 0-213.8 66.5 0 0 213.8-.1 0zM102.2 96a38.5 38.5 0 1 1 0 77 38.5 38.5 0 1 1 0-77zM384.3 416l-66.4 0 0-104c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9l0 105.8-66.4 0 0-213.8 63.7 0 0 29.2 .9 0c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9l0 117.2z"
            /></svg
          ><span class="visually-hidden">LinkedIn</span></a
        >
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://www.pinterest.com/uamshealth/" target="_blank" title="Pinterest"
          ><svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
            ><path
              fill="currentColor"
              d="M504 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3 .8-3.4 5-20.3 6.9-28.1 .6-2.5 .3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2C161.5 437.2 163.5 467.4 165.6 487 73.4 450.9 8 361.1 8 256 8 119 119 8 256 8S504 119 504 256z"
            /></svg
          ><span class="visually-hidden">Pinterest</span></a
        >
      </li>
    </ul>
  </nav>
  <nav aria-label="Footer Navigation">
    <ul class="nav legal">
      <li class="nav-item">
        <a class="nav-link" href="https://www.uamshealth.com/disclaimer/">Disclaimer</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://www.uamshealth.com/termsofuse/">Terms of Use</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://www.uamshealth.com/privacy/">Privacy Statement</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://hipaa.uams.edu/forms/notice-of-privacy-practices-information/"
          >Notice of Privacy Practices</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          href="https://uamshealth.com/patients-and-guests/patient-support/billing/price-transparency/"
          >Price Transparency</a
        >
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://uamshealth.com/legal-notices/">Legal Notices</a>
      </li>
    </ul>
  </nav>
  <p class="copyright">
    &copy; {currentYear}
    <a href={itdevcontact}> University of Arkansas for Medical Sciences </a>
  </p>
  <p class="copyright">
    Badge and trophy icons designed by <a href="https://www.flaticon.com/authors/good-ware">Good Ware - Flaticon</a>
  </p>
</footer>

<style>
  footer {
    padding: 3rem 2rem;
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    background-color: var(--uams-primary-red);
    text-align: center;
    color: #f5f3f4;
  }

  a:not(.btn) {
    color: #ffffff;
  }

  .logo {
    display: block;
    margin: 0 auto;
  }

  .logo img {
    height: 2.5rem;
  }

  .schema {
    font-size: 1rem;
  }

  .schema .schema-phone {
    margin-top: 0.5rem;
  }

  p {
    margin-bottom: 0;
  }

  .copyright {
    font-size: 0.84375rem;
  }

  .logo,
  .nav,
  .schema {
    margin-bottom: 1.5rem;
  }

  .copyright,
  .logo,
  .nav,
  .schema {
    z-index: 1;
    position: relative;
  }

  .nav {
    justify-content: center;
    line-height: 1;
  }

  .nav.social {
    font-size: 2rem;
  }

  .nav-link {
    transition: none;
  }

  .svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
    width: 1em;
  }

  .svg-inline--fa.fa-w-14 {
    width: 0.875em;
  }

  .svg-inline--fa.fa-w-18 {
    width: 1.125em;
  }

  .nav.legal {
    font-size: 1.125rem;
    flex-direction: column;
  }

  .nav .nav-item:not(:last-child) {
    margin-bottom: 10px;
  }

  .nav.social .nav-item .nav-link {
    padding: 0.25rem;
  }

  .nav.legal .nav-item .nav-link {
    padding: 0.25rem 1rem;
    font-weight: 300;
  }

  .nav .nav-item .nav-link:active,
  .nav .nav-item .nav-link:focus,
  .nav .nav-item .nav-link:hover {
    text-decoration: underline;
    color: #f0dee1;
  }

  @media (max-width: 1200px) {
    .nav.social {
      font-size: calc(1.325rem + 0.9vw);
    }
  }

  @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
    footer:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 0;
      mix-blend-mode: overlay;
      opacity: 0.3;
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
      background-image: url($lib/assets/img/fountain_767x650.jpg);
      background-size: cover;
      background-position: 50%;
      background-repeat: no-repeat;
    }
  }

  @media (min-width: 576px) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_767x650.jpg);
      }
    }
  }

  @media (min-width: 768px) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_992x372.jpg);
      }
    }

    .nav .nav-item {
      padding: 0 5px;
    }

    .nav .nav-item:not(:last-child) {
      margin-bottom: 0;
    }

    .nav.legal .nav-item:not(:last-child) {
      border-right: 1px solid hsla(0, 0%, 100%, 0.5);
    }

    .nav.legal {
      flex-direction: row;
    }
  }

  @media (min-width: 992px) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_1200x450.jpg);
      }
    }
  }

  @media (min-width: 1200px) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_1500x563.jpg);
      }
    }
  }

  @media (min-width: 1500px) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_1921x720.jpg);
      }
    }
  }

  @media (min-width: 1921px) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_2560x960.jpg);
      }
    }
  }

  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_1340x1340.jpg);
      }
    }
  }

  @media (min-width: 576px) and (-webkit-min-device-pixel-ratio: 2), (min-width: 576px) and (min-resolution: 192dpi) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_1534x1300.jpg);
      }
    }
  }

  @media (min-width: 768px) and (-webkit-min-device-pixel-ratio: 2), (min-width: 768px) and (min-resolution: 192dpi) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_1984x744.jpg);
      }
    }
  }

  @media (min-width: 992px) and (-webkit-min-device-pixel-ratio: 2), (min-width: 992px) and (min-resolution: 192dpi) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_2400x900.jpg);
      }
    }
  }

  @media (min-width: 1200px) and (-webkit-min-device-pixel-ratio: 2), (min-width: 1200px) and (min-resolution: 192dpi) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_3000x1125.jpg);
      }
    }
  }

  @media (min-width: 1500px) and (-webkit-min-device-pixel-ratio: 2), (min-width: 1500px) and (min-resolution: 192dpi) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_3842x1441.jpg);
      }
    }
  }

  @media (min-width: 1921px) and (-webkit-min-device-pixel-ratio: 2), (min-width: 1921px) and (min-resolution: 192dpi) {
    @supports (mix-blend-mode: overlay) and ((-webkit-filter: grayscale(100%)) or (filter: grayscale(100%))) {
      footer:before {
        background-image: url($lib/assets/img/fountain_5120x1920.jpg);
      }
    }
  }
</style>
